import React from 'react'
import { DealerForm } from './DealerForm'

export const AddDealerTOJB360Tool = () => {
  return (
    <DealerForm />
  )
}
